import 'css-chunksrc/client/pages/exportsPage/timesheetByTaskReport/styles.scss';export default {
  "wbsReport": "_wbsReport_o6prv_1",
  "checked": "_checked_o6prv_7",
  "row": "_row_o6prv_11",
  "checkbox": "_checkbox_o6prv_20",
  "col": "_col_o6prv_26",
  "name": "_name_o6prv_30",
  "description": "_description_o6prv_37",
  "filters": "_filters_o6prv_42",
  "group": "_group_o6prv_51",
  "label": "_label_o6prv_60",
  "button": "_button_o6prv_67",
  "integrationDateFilterInput": "_integrationDateFilterInput_o6prv_71",
  "integrationDateFilterTypeName": "_integrationDateFilterTypeName_o6prv_78"
};